import { render } from "./testMenu.vue?vue&type=template&id=5c5ce25c"
import script from "./testMenu.vue?vue&type=script&lang=js"
export * from "./testMenu.vue?vue&type=script&lang=js"

import exportComponent from "E:\\edu-ui\\HyEducationAdmin\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__